<template>
  <div id="app">
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from './components/SiteFooter.vue';

export default {
  name: 'App',
  components: {
    SiteFooter
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 20px;
}

#app {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>